var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { html, LitElement, nothing } from "lit";
import { createRef, ref } from "lit/directives/ref.js";
import { customElement, property, state } from "lit/decorators.js";
const customEl = "menu-burger";
let MenuBurger = class MenuBurger extends LitElement {
    constructor() {
        super(...arguments);
        this.labelOpen = "";
        this.labelClosed = "";
        this.iconOpen = "";
        this.iconClosed = "";
        this.isActive = false;
        this.buttonRef = createRef();
    }
    _handleClick() {
        this.isActive = !this.isActive;
        this.isActive
            ? this.buttonRef.value?.setAttribute("data-active", "")
            : delete this.buttonRef.value?.dataset.active;
        this.dispatchEvent(new CustomEvent("menu-burger-click", {
            detail: { isActive: this.isActive },
            bubbles: true,
            composed: true,
        }));
    }
    render() {
        return html `
      <button 
      ${ref(this.buttonRef)}
      @click=${this._handleClick}
      class="group/burger dark-menu:text-white relative z-10 flex w-fit touch-manipulation items-center gap-2 text-black">
        <div class="flex size-[--icon-size] items-center contain-paint">
          <div class="flex w-max items-center">
            <svg data-icon="open" class="size-[--icon-size] fill-current p-1 transition-all duration-m group-data-[active]/burger:-translate-x-full group-data-[active]/burger:rotate-180" aria-hidden="true">
              <use href="${this.iconClosed}"></use>
            </svg>
            <svg data-icon="close" class="size-[--icon-size] fill-current p-1 transition-all duration-m group-data-[active]/burger:-translate-x-full group-data-[active]/burger:rotate-180" aria-hidden="true">
              <use href="${this.iconOpen}"></use>
            </svg>
          </div>
        </div>
        ${this.labelOpen && this.labelClosed
            ? html `<div class="hidden md:block">
            <div class="grid grid-cols-1 grid-rows-1 contain-paint">
              <span class="col-start-1 row-start-1 text-xl transition-all duration-m group-data-[active]/burger:-translate-y-full">${this.labelOpen}</span>
              <span class="col-start-1 row-start-1 translate-y-full text-xl transition-all duration-m group-data-[active]/burger:translate-y-0">${this.labelClosed}</span>
            </div>
          </div>`
            : nothing}
      </button>
    `;
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    property({ type: String, attribute: "label-open" }),
    __metadata("design:type", Object)
], MenuBurger.prototype, "labelOpen", void 0);
__decorate([
    property({ type: String, attribute: "label-closed" }),
    __metadata("design:type", Object)
], MenuBurger.prototype, "labelClosed", void 0);
__decorate([
    property({ type: String, attribute: "icon-open" }),
    __metadata("design:type", Object)
], MenuBurger.prototype, "iconOpen", void 0);
__decorate([
    property({ type: String, attribute: "icon-closed" }),
    __metadata("design:type", Object)
], MenuBurger.prototype, "iconClosed", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], MenuBurger.prototype, "isActive", void 0);
MenuBurger = __decorate([
    customElement(customEl)
], MenuBurger);
export { MenuBurger };
